/**
 * Globaler Schutz gegen NumLock-aus auf dem Ziffernblock:
 * Ohne NumLock sendet Taste "2"/"8" ArrowDown/ArrowUp → Browser steppt <input type="number">.
 */
export function installNumberInputKeyGuard(): () => void {
  const onKeyDown = (e: KeyboardEvent) => {
    const target = e.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.type !== 'number') return;
    if (target.readOnly || target.disabled) return;

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      return;
    }

    if (e.key === '-') {
      const minAttr = target.getAttribute('min');
      if (minAttr !== null && minAttr !== '' && Number(minAttr) >= 0) {
        e.preventDefault();
      }
    }
  };

  document.addEventListener('keydown', onKeyDown, true);
  return () => document.removeEventListener('keydown', onKeyDown, true);
}
